import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import {
  TrustBar,
  NeedToday,
  SameDayBand,
  WhyChoose,
  ComfortSystem,
  HowItWorks,
  Reviews,
  FinancingPlan,
  ServiceArea,
  BookingCta,
  Footer,
} from "./components/Sections";

export default function Home() {
  return (
    <main className="bg-white text-brand-navy overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <NeedToday />
      <SameDayBand />
      <WhyChoose />
      <ComfortSystem />
      <HowItWorks />
      <Reviews />
      <FinancingPlan />
      <ServiceArea />
      <BookingCta />
      <Footer />
    </main>
  );
}